module.exports = __webpack_public_path__ + "media/images/PWebText-3ca5d45cf25599f32be81a3cf4158a40.png";